import { render, staticRenderFns } from "./menuManage.vue?vue&type=template&id=3311800f&scoped=true&"
import script from "./menuManage.vue?vue&type=script&lang=js&"
export * from "./menuManage.vue?vue&type=script&lang=js&"
import style0 from "./menuManage.vue?vue&type=style&index=0&id=3311800f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3311800f",
  null
  
)

export default component.exports